import React from "react";
import tackoffImg from "./../assets/png/takeoff.png";
function Takeoff() {
  return (
    <>
      <div className="tackoff-bg ">
        <div
          id="tackoff"
          className="max-w-[1624px] mx-auto px-4 sm:px-6 lg:px-8 my-12 py-10 sm:py-16 lg:py-10 w-full"
        >
          <div className="flex flex-col-reverse md:flex-row gap-y-6 items-center">
            <div
              className="max-w-[450px] lg:max-w-[960px]"
              data-aos="fade-up-right"
              data-aos-duration="1000"
            >
              <img src={tackoffImg} alt="img" className="w-full" />
            </div>{" "}
            <div className="max-w-[796px] md:-ml-10 2xl:-ml-20">
              <h2
                className="text-black text-3xl sm:text-5xl  xl:text-[70px] 2xl:text-[100px] text-aircruiser xl:tracking-[-2px] text-shadow-2"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                Play the Josh game now
              </h2>
              <p
                className="text-black text-base sm:text-lg xl:text-xl 2xl:text-[24px] leading-[180%] lg:tracking-[0.48px] py-4 md:py-6 xl:py-8 2xl:py-10 md:max-w-[640px]"
                data-aos="fade-left"
                data-aos-duration="2000"
              >
                The Josh game is now available for you to play. Based on the
                daily high score the team will be burning tokens live on
                telegram and YouTube.
              </p>{" "}
              <div
                className="flex  gap-3 sm:gap-4 xl:gap-6 flex-nowrap"
                data-aos="fade-left"
                data-aos-duration="3000"
              >
                <a
                  href="https://josh-hero-03.netlify.app/"
                  className="bg-[#0279E1] py-2.5 sm:py-3 xl:py-5 px-5 sm:px-6 xl:px-14 2xl:px-16 border border-black rounded-xl 
               shadow-[0px_6px_0px_0px_#000] text-white text-lg md:text-xl 2xl:text-2xl  text-aircruiser   transition-all duration-300 ease-in-out hover:shadow-[0px_6px_20px_0px_#000] uppercase
              "
                >
                  Play now
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Takeoff;
